// extracted by mini-css-extract-plugin
module.exports = {"menu_div":"LeftMenu_menu_div__2TLdV","alarm_div1":"LeftMenu_alarm_div1__3sBqh","alarm_div2":"LeftMenu_alarm_div2__z69AU"};